var SupportMultipleQtyPopupView, SupportReturnItemsServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View');

SupportReturnItemsServiceActionView = (function(superClass) {
  extend(SupportReturnItemsServiceActionView, superClass);

  function SupportReturnItemsServiceActionView() {
    return SupportReturnItemsServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportReturnItemsServiceActionView.prototype.id = 'id_return_item';

  SupportReturnItemsServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportReturnItemsServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportReturnItemsServiceActionView.prototype.toHash = function() {
    var button_title, hash, ref;
    button_title = ((ref = this.order.groupons) != null ? ref.length : void 0) > 1 ? I18n.t("js.modules.support.return_all_items") : I18n.t("js.modules.support.return_item");
    hash = {
      service_action_id: "return_item",
      service_action: button_title
    };
    return this.extendHash(hash);
  };

  SupportReturnItemsServiceActionView.prototype.actionHandler = function(event) {
    var args, currentOrder, multipleQtyPopup, ref;
    currentOrder = Groupon.Support.currentOrder;
    if (window.showMultiReturnItemPopup && ((ref = currentOrder.groupons) != null ? ref.length : void 0) > 1) {
      args = {
        orders: this.order,
        serviceActionName: 'return_item',
        singleActionButtonCallback: this.getUrlForVoucher,
        groupActionButtonCallback: this.getUrlForAllVouchers,
        showgroupActionButton: false,
        title: I18n.t("js.modules.support.return_all_items"),
        singleActionButtonName: I18n.t("js.modules.support.return_item"),
        groupActionButtonName: I18n.t("js.modules.support.return_all_items")
      };
      multipleQtyPopup = new SupportMultipleQtyPopupView(args);
      multipleQtyPopup.render();
    } else {
      openLocation(currentOrder.returnItemUrl);
    }
    return true;
  };

  SupportReturnItemsServiceActionView.prototype.getUrlForAllVouchers = function(order_id) {
    return null;
  };

  SupportReturnItemsServiceActionView.prototype.getUrlForVoucher = function(groupon) {
    return groupon.returnItemUrl;
  };

  SupportReturnItemsServiceActionView.prototype.events = {
    "click #return_item": "actionHandler"
  };

  return SupportReturnItemsServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportReturnItemsServiceActionView;

//# sourceMappingURL=data:application/json;base64,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
